import Vuex from 'vuex';
import createLogger from 'vuex/dist/logger';

import auth from './auth';
import toast from './toasts.js';

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
  modules: {
    auth,
    toast,
  },
  strict: debug,
  plugins: debug ? [createLogger()] : [],
});